<section class="auth-showcase">
  <div class="auth-showcase__hero">
    <div class="auth-showcase__intro">
      <div class="auth-showcase__brand">
        <img src="HTallyIcon.png" alt="HTally" class="auth-showcase__logo" />
        <span class="auth-showcase__brand-name">HTally</span>
      </div>

      <div class="auth-showcase__copy">
        <p class="auth-showcase__description">{{ localize(showcaseDescription) }}</p>
      </div>
    </div>

    <div class="auth-showcase__visual">
      <img src="IllustrationOfAccounts.png" alt="Auth illustration" class="auth-showcase__image" />
    </div>
  </div>

  <div class="auth-showcase__features" #featuresCard>
    <div class="auth-showcase__features-heading" #featuresHeading>
      <div class="auth-showcase__features-title">{{ localize(featureHeading) }}</div>
      <span class="auth-showcase__features-accent" aria-hidden="true"></span>
    </div>
    <div class="auth-showcase__feature-grid" #featureGrid [style.max-height.px]="featureGridMaxHeight">
      @for (feature of visibleFeatures; track feature.title.en) {
      <div class="auth-showcase__feature">
        <span class="auth-showcase__feature-icon" [innerHTML]="feature.icon"></span>
        <span class="auth-showcase__feature-text">{{ localize(feature.title) }}</span>
      </div>
      }
      @if (shouldShowFeatureToggle) {
      <button type="button" class="auth-showcase__more-btn auth-showcase__more-btn--tile" (click)="toggleFeatures()">
        {{ isFeaturesExpanded ? 'Less features' : 'More features' }}
        <span aria-hidden="true">{{ isFeaturesExpanded ? '↑' : '→' }}</span>
      </button>
      }
    </div>
  </div>
</section>
